var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoomPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boom-play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.9865C13.5 9.05405 11.949 7.47297 10.0534 7.47297C11.6388 7.4027 12.8451 6.06757 12.8451 4.48649C12.8451 2.83514 11.5699 1.5 9.95 1.5H5.883C5.67621 1.5 5.46941 1.64054 5.43494 1.85135L5.15415 3.15992L8.77667 3.57408C8.78326 3.57483 8.78971 3.57595 8.79602 3.57742C9.46908 3.63315 9.99825 4.20764 9.99825 4.90812C9.99825 5.6455 9.41187 6.24326 8.68854 6.24326C7.96521 6.24326 7.37883 5.6455 7.37883 4.90812C7.37883 4.46492 7.59066 4.07216 7.91675 3.82932L5.08009 3.50501L3.99197 8.57586L8.46659 9.09031C8.47706 9.09152 8.48719 9.09365 8.49693 9.09662C9.30074 9.17511 9.92932 9.86543 9.92932 10.7054C9.92932 11.598 9.21949 12.3216 8.34388 12.3216C7.46827 12.3216 6.75844 11.598 6.75844 10.7054C6.75844 10.1266 7.0569 9.61886 7.5055 9.33339L3.91793 8.92092L3.02232 13.0946C2.88446 13.8324 3.40145 14.5 4.12523 14.5H10.0534C11.949 14.5 13.5 12.9189 13.5 10.9865Z",
    fill: "#00FFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomPlay);
export default __webpack_public_path__ + "static/media/boom-play.0f27182ed9d718ad441b63e6b7311eca.svg";
export { ForwardRef as ReactComponent };